"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var commonFields = exports.commonFields = [{
    "name": "site_id",
    "type": "string"
}, {
    "name": "organization_id",
    "type": "string"
}, {
    "name": "instance_id",
    "type": "string"
}, {
    "name": "bi_token",
    "type": "string"
}, {
    "name": "biToken",
    "type": "string"
}, {
    "name": "ownerId",
    "type": "string"
}, {
    "name": "roles",
    "type": "string"
}, {
    "name": "msid",
    "type": "string"
}, {
    "name": "_c",
    "type": "string"
}, {
    "name": "src",
    "type": "number"
}];

var events = exports.events = {
    "MENUS_SETTINGS_OPEN": {
        "id": 12,
        "fields": [{
            "name": "origin",
            "type": "string"
        }]
    },
    "MENUS_SETTINGS_LOAD": {
        "id": 13,
        "fields": [{
            "name": "origin",
            "type": "string"
        }]
    },
    "MENUS_SETTINGS_CLOSE": {
        "id": 14,
        "fields": [{
            "name": "origin",
            "type": "string"
        }]
    },
    "MENUS_SETTINGS_CREATE_MENU_CLICK": {
        "id": 15,
        "fields": [{
            "name": "origin",
            "type": "string"
        }]
    },
    "MENUS_SETTINGS_TAB_OPEN": {
        "id": 16,
        "fields": [{
            "name": "level",
            "type": "string"
        }]
    },
    "MENUS_SETTINGS_SET_LAYOUT": {
        "id": 17,
        "fields": [{
            "name": "layout",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }]
    },
    "SETTINGS_ELEMENTS_TOGGLE": {
        "id": 18,
        "fields": [{
            "name": "appName",
            "type": "string"
        }, {
            "name": "areaName",
            "type": "string"
        }, {
            "name": "element",
            "type": "string"
        }, {
            "name": "index",
            "type": "number"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "toggle",
            "type": "boolean"
        }]
    },
    "MENUS_SETTINGS_AUTOUPGRADE_TOGGLE": {
        "id": 19,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "toggle",
            "type": "boolean"
        }]
    },
    "MENUS_SETTINGS_SET_STYLE_FONT": {
        "id": 20,
        "fields": [{
            "name": "font",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "style",
            "type": "string"
        }]
    },
    "MENUS_SETTINGS_SET_STYLE_COLOR": {
        "id": 21,
        "fields": [{
            "name": "color",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "style",
            "type": "string"
        }]
    },
    "MENUS_SETTINGS_SET_STYLE_OPACITY": {
        "id": 22,
        "fields": [{
            "name": "opacity",
            "type": "number"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "style",
            "type": "string"
        }]
    },
    "ONBOARDING_OPEN": {
        "id": 23
    },
    "ONBOARDING_LOAD": {
        "id": 24
    },
    "ONBOARDING_LETS_GO_CLICK": {
        "id": 25
    },
    "ONBOARDING_BASIC_SET": {
        "id": 26,
        "fields": [{
            "name": "address",
            "type": "string"
        }, {
            "name": "address_ok",
            "type": "boolean"
        }, {
            "name": "phone",
            "type": "string"
        }, {
            "name": "phone_ok",
            "type": "boolean"
        }, {
            "name": "title",
            "type": "string"
        }, {
            "name": "title_ok",
            "type": "boolean"
        }]
    },
    "ONBOARDING_BASIC_TITLE_ERROR": {
        "id": 27
    },
    "ONBOARDING_BASIC_ADDRESS_ERROR": {
        "id": 28
    },
    "ONBOARDING_BASIC_PHONE_ERROR": {
        "id": 29
    },
    "ONBOARDING_BASIC_SET_FIELD": {
        "id": 30,
        "fields": [{
            "name": "field",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "ONBOARDING_BASIC_OK_CLICK": {
        "id": 31
    },
    "ONBOARDING_BASIC_SAVE_CLICK": {
        "id": 32
    },
    "ONBOARDING_BASIC_SAVE_SUCCESS": {
        "id": 33,
        "fields": [{
            "name": "time_from_save_click",
            "type": "number"
        }]
    },
    "ONBOARDING_BASIC_SAVE_ERROR": {
        "id": 34,
        "fields": [{
            "name": "code",
            "type": "string"
        }]
    },
    "ONBOARDING_TAKEMETHERE_CLICK": {
        "id": 35
    },
    "ONBOARDING_DETAILS_SKIP": {
        "id": 36,
        "fields": [{
            "name": "screenName",
            "type": "string"
        }]
    },
    "DASHBOARD_LOAD": {
        "id": 37
    },
    "DASHBOARD_ORDERS_TEASER_CLICK": {
        "id": 38
    },
    "DASHBOARD_ORDERS_TEASER_REPORT": {
        "id": 39
    },
    "DASHBOARD_ORDERS_TEASER_REPORT_SUCCESS": {
        "id": 40
    },
    "DASHBOARD_ORDERS_TEASER_REPORT_ERROR": {
        "id": 41
    },
    "DASHBOARD_TAB_OPEN": {
        "id": 42,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "tab",
            "type": "string"
        }]
    },
    "DASHBOARD_HELP_CLICK": {
        "id": 43,
        "fields": [{
            "name": "origin",
            "type": "string"
        }]
    },
    "DASHBOARD_FEEDBACK_CLICK": {
        "id": 44,
        "fields": [{
            "name": "origin",
            "type": "string"
        }]
    },
    "DASHBOARD_SETTINGS_SET_FIELD": {
        "id": 45,
        "fields": [{
            "name": "field",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_SETTINGS_CANCEL_CLICK": {
        "id": 46,
        "fields": [{
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_SETTINGS_SAVE_CLICK": {
        "id": 47,
        "fields": [{
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_MENU_ADD_DIALOG_CLOSE": {
        "id": 48,
        "fields": [{
            "name": "origin",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_MENU_ADD_DIALOG_OK_CLICK": {
        "id": 49,
        "fields": [{
            "name": "is_diwm_menu",
            "type": "boolean"
        }]
    },
    "DASHBOARD_MENUS_MENU_ADD_DIALOG_FIELD_ERROR": {
        "id": 50,
        "fields": [{
            "name": "field",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_MENU_ADD_DIALOG_SET_FIELD": {
        "id": 51,
        "fields": [{
            "name": "field",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_SAVE_CLICK": {
        "id": 52
    },
    "DASHBOARD_MENUS_SAVE_SUCCESS": {
        "id": 53
    },
    "DASHBOARD_MENUS_SAVE_ERROR": {
        "id": 54,
        "fields": [{
            "name": "code",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_MENU_OPEN": {
        "id": 55,
        "fields": [{
            "name": "menu",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_MENU_DELETE_CLICK": {
        "id": 56,
        "fields": [{
            "name": "menu",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_MENU_EDIT": {
        "id": 57,
        "fields": [{
            "name": "editLevel",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_MENU_DELETE_DIALOG_CLOSE": {
        "id": 58,
        "fields": [{
            "name": "origin",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_MENU_DELETE_DIALOG_OK_CLICK": {
        "id": 59
    },
    "DASHBOARD_MENUS_MENU_EDIT_CANCEL": {
        "id": 60,
        "fields": [{
            "name": "menu",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_MENU_EDIT_SAVE": {
        "id": 61,
        "fields": [{
            "name": "isVisible",
            "type": "boolean"
        }, {
            "name": "menu",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_MENU_EDIT_SET_FIELD": {
        "id": 62,
        "fields": [{
            "name": "field",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_SECTION_ADD_CLICK": {
        "id": 63,
        "fields": [{
            "name": "is_diwm_menu",
            "type": "boolean"
        }, {
            "name": "menu",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_SECTION_DELETE_CLICK": {
        "id": 64,
        "fields": [{
            "name": "menu",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_SECTION_DELETE_DIALOG_CLOSE": {
        "id": 65,
        "fields": [{
            "name": "origin",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_SECTION_DELETE_DIALOG_OK_CLICK": {
        "id": 66
    },
    "DASHBOARD_MENUS_SECTION_EDIT": {
        "id": 67,
        "fields": [{
            "name": "menu",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_SECTION_EDIT_ADD_DIALOG_OK_CLICK": {
        "id": 68,
        "fields": [{
            "name": "is_diwm_menu",
            "type": "boolean"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_SECTION_EDIT_SAVE": {
        "id": 69,
        "fields": [{
            "name": "isVisible",
            "type": "boolean"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_SECTION_EDIT_SET_FIELD": {
        "id": 70,
        "fields": [{
            "name": "field",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_SECTION_REORDER": {
        "id": 71,
        "fields": [{
            "name": "menu",
            "type": "string"
        }, {
            "name": "position_after",
            "type": "string"
        }, {
            "name": "position_before",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_ADD_CLICK": {
        "id": 72,
        "fields": [{
            "name": "dishId",
            "type": "string"
        }, {
            "name": "is_diwm_menu",
            "type": "boolean"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_ADD_DIALOG_CLOSE": {
        "id": 73,
        "fields": [{
            "name": "origin",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_ADD_DIALOG_OK_CLICK": {
        "id": 74,
        "fields": [{
            "name": "dishId",
            "type": "string"
        }, {
            "name": "is_diwm_menu",
            "type": "boolean"
        }, {
            "name": "isDuplicate",
            "type": "boolean"
        }, {
            "name": "isGlutenFree",
            "type": "boolean"
        }, {
            "name": "isInStock",
            "type": "boolean"
        }, {
            "name": "isNew",
            "type": "boolean"
        }, {
            "name": "isOrganic",
            "type": "boolean"
        }, {
            "name": "isShown",
            "type": "boolean"
        }, {
            "name": "isSpecial",
            "type": "boolean"
        }, {
            "name": "isSpicy",
            "type": "boolean"
        }, {
            "name": "isSuccess",
            "type": "boolean"
        }, {
            "name": "isVegan",
            "type": "boolean"
        }, {
            "name": "isVegetarian",
            "type": "boolean"
        }, {
            "name": "template",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_ADD_DIALOG_SET_FIELD": {
        "id": 75,
        "fields": [{
            "name": "field",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_ADD_DIALOG_FIELD_ERROR": {
        "id": 76,
        "fields": [{
            "name": "field",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_ADD_DIALOG_TEMPLATE_CLICK": {
        "id": 77,
        "fields": [{
            "name": "template",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_ADD_DIALOG_ADD_NEW_CHOICE_CLICK": {
        "id": 78
    },
    "DASHBOARD_MENUS_DISH_ADD_DIALOG_CHOICE_SET_FIELD": {
        "id": 79,
        "fields": [{
            "name": "choice",
            "type": "string"
        }, {
            "name": "field",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_ADD_DIALOG_CHOICE_AUTOCOMPLETE_CLICK": {
        "id": 80,
        "fields": [{
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_ADD_DIALOG_CHOICE_DELETE": {
        "id": 81,
        "fields": [{
            "name": "choice",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_EDIT": {
        "id": 82,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_EDIT_CANCEL": {
        "id": 83,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_EDIT_SET_FIELD": {
        "id": 84,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "field",
            "type": "string"
        }, {
            "name": "firstsuggestion",
            "type": "string"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_EDIT_FIELD_ERROR": {
        "id": 85,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "field",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_EDIT_NEW_CHOICE_CLICK": {
        "id": 86,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "option",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_EDIT_CHOICE_SET_FIELD": {
        "id": 87,
        "fields": [{
            "name": "choice",
            "type": "string"
        }, {
            "name": "dish",
            "type": "string"
        }, {
            "name": "field",
            "type": "string"
        }, {
            "name": "firstsuggestion",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "option",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_EDIT_CHOICE_AUTOCOMPLETE_CLICK": {
        "id": 88,
        "fields": [{
            "name": "choice",
            "type": "string"
        }, {
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "option",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }, {
            "name": "selection",
            "type": "string"
        }, {
            "name": "text",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_EDIT_CHOICE_DELETE": {
        "id": 89,
        "fields": [{
            "name": "choice",
            "type": "string"
        }, {
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "option",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_SET_IMAGE": {
        "id": 90,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_DELETE_IMAGE": {
        "id": 91,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_EDIT_SAVE": {
        "id": 92,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_ADD_MENU_CLICK": {
        "id": 93,
        "fields": [{
            "name": "is_diwm_menu",
            "type": "boolean"
        }, {
            "name": "menuId",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_MENU_EDIT_FIELD_ERROR": {
        "id": 94,
        "fields": [{
            "name": "field",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_SECTION_EDIT_FIELD_ERROR": {
        "id": 95,
        "fields": [{
            "name": "field",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_DELETE_CLICK": {
        "id": 96,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_DELETE_DIALOG_CLOSE": {
        "id": 97,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_DELETE_DIALOG_OK_CLICK": {
        "id": 98,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_REORDER": {
        "id": 99,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "position_after",
            "type": "string"
        }, {
            "name": "position_before",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_SECTION_COLLAPSE": {
        "id": 100,
        "fields": [{
            "name": "menu",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_SECTION_EXPAND": {
        "id": 101,
        "fields": [{
            "name": "menu",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_CHOICE_REORDER": {
        "id": 102,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "option",
            "type": "string"
        }, {
            "name": "position_after",
            "type": "string"
        }, {
            "name": "position_before",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_EDIT_CHOICE_FIELD_ERROR": {
        "id": 103,
        "fields": [{
            "name": "choice",
            "type": "string"
        }, {
            "name": "dish",
            "type": "string"
        }, {
            "name": "field",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "option",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_EDIT_AUTOCOMPLETE_CLICK": {
        "id": 104,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }, {
            "name": "selection",
            "type": "string"
        }, {
            "name": "text",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_ADD_OPTION": {
        "id": 105,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_DELETE_OPTION": {
        "id": 106,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "option",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_EDIT_OPTION_SET_FIELD": {
        "id": 107,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "field",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "option",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_EDIT_OPTION_FIELD_ERROR": {
        "id": 108,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "field",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "option",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_ADD_LABEL": {
        "id": 109,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "label_name",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_DISH_REMOVE_LABEL": {
        "id": 110,
        "fields": [{
            "name": "dish",
            "type": "string"
        }, {
            "name": "label_name",
            "type": "string"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "mode",
            "type": "string"
        }, {
            "name": "section",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_OVERVIEWPAGE_OLO_TOGGLE": {
        "id": 111,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_OVERVIEWPAGE_OPEN_EDIT_MODAL_OF_FEATURE_ACTIVATION": {
        "id": 112,
        "fields": [{
            "name": "source",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_OVERVIEWPAGE_EDIT_MODAL_APPLY_BUTTON": {
        "id": 113,
        "fields": [{
            "name": "comment_added",
            "type": "boolean"
        }, {
            "name": "source",
            "type": "string"
        }, {
            "name": "time_limit",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_OVERVIEWPAGE_EDIT_MODAL_CANCEL_BUTTON": {
        "id": 114,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_OVERVIEWPAGE_DISPLAY_MENUS_CHECK_BOX": {
        "id": 115,
        "fields": [{
            "name": "active_menus",
            "type": "number"
        }, {
            "name": "inactive_menus",
            "type": "number"
        }, {
            "name": "menu",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_UPPER_TAB_CLICK": {
        "id": 116,
        "fields": [{
            "name": "source",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_PICKUP_PAGE_PICKUP_TOGGLE": {
        "id": 117,
        "fields": [{
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_PICKUP_PAGE_EDIT_DELIVERY_HOURS_CLICK_ON_LINK": {
        "id": 118
    },
    "DASHBOARD_OLO_PICKUP_PAGE_DELIVERY_HOURS_APPLY_CHANGES": {
        "id": 119
    },
    "DASHBOARD_OLO_PICKUP_PAGE_CLOSE_WINDOW_DELIVERY_HOURS": {
        "id": 120
    },
    "DASHBOARD_OLO_OVERVIEWPAGE_CREATE_MENU_LINK_CLICK": {
        "id": 121
    },
    "DASHBOARD_OLO_PICKUP_PAGE_PICK_UP_SETTINGS_SAVE": {
        "id": 122,
        "fields": [{
            "name": "availability",
            "type": "string"
        }, {
            "name": "availability_modified",
            "type": "boolean"
        }, {
            "name": "curbsidePickupAdditionalInformation",
            "type": "string"
        }, {
            "name": "curbsidePickupCheckBox",
            "type": "string"
        }, {
            "name": "curbsidePickupContent",
            "type": "string"
        }, {
            "name": "delivery_time",
            "type": "number"
        }, {
            "name": "error_desc",
            "type": "string"
        }, {
            "name": "result",
            "type": "string"
        }, {
            "name": "validationError",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_PICKUP_PAGE_PICKUP_SETTINGS_CANCEL": {
        "id": 123
    },
    "DASHBOARD_OLO_PAYMENT_PAGE_OPEN_EDIT_CREDIT_CARD_MODAL": {
        "id": 124,
        "fields": [{
            "name": "source",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_PAYMENT_PAGE_CASH_TOGGLE": {
        "id": 125,
        "fields": [{
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_PAYMENT_PAGE_CREDIT_CARD_TOGGLE": {
        "id": 126,
        "fields": [{
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_PAYMENT_PAGE_ACTIVATE_CREDIT_CARD_CLICK": {
        "id": 127,
        "fields": [{
            "name": "card_mandatory_fields",
            "type": "string"
        }, {
            "name": "credit_cards",
            "type": "string"
        }, {
            "name": "manual_collection_type",
            "type": "string"
        }, {
            "name": "online_gateway",
            "type": "string"
        }, {
            "name": "payments_method",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_PAYMENT_PAGE_CANCEL_CREDIT_CARD_ACTIVATION": {
        "id": 128,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_RECEIVING_ORDERS_SETTINGS_SAVE": {
        "id": 129,
        "fields": [{
            "name": "error_desc",
            "type": "string"
        }, {
            "name": "notify_delay",
            "type": "number"
        }, {
            "name": "notify_method",
            "type": "string"
        }, {
            "name": "notify_value",
            "type": "string"
        }, {
            "name": "receive_method",
            "type": "string"
        }, {
            "name": "receive_value",
            "type": "string"
        }, {
            "name": "result",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_RECEIVING_ORDERS_SETTINGS_CANCEL_CLICK": {
        "id": 130
    },
    "DASHBOARD_OLO_DELIVERY_ADD_DELIVERY_AREA_CLICK": {
        "id": 131
    },
    "DASHBOARD_OLO_DELIVERY_ADD_LOCATION": {
        "id": 132
    },
    "DASHBOARD_OLO_DELIVERY_DELIVERY_HOURS_APPLY_CHANGES": {
        "id": 133
    },
    "DASHBOARD_OLO_DELIVERY_DELIVERY_HOURS_CLOSE_WINDOW": {
        "id": 134
    },
    "DASHBOARD_OLO_DELIVERY_AREA_SELECT_METHOD": {
        "id": 135,
        "fields": [{
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_DELIVERY_CANCEL_DELIVERY_AREA_WINDOW": {
        "id": 136,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_DELIVERY_SAVE_DELIVERY_AREA": {
        "id": 137,
        "fields": [{
            "name": "areaName",
            "type": "string"
        }, {
            "name": "availability",
            "type": "string"
        }, {
            "name": "availability_modified",
            "type": "boolean"
        }, {
            "name": "deliveryCharges",
            "type": "number"
        }, {
            "name": "error_desc",
            "type": "string"
        }, {
            "name": "index",
            "type": "number"
        }, {
            "name": "isRadius",
            "type": "boolean"
        }, {
            "name": "minimumOrder",
            "type": "number"
        }, {
            "name": "name",
            "type": "string"
        }, {
            "name": "result",
            "type": "string"
        }, {
            "name": "selection_method",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }, {
            "name": "state",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_DELIVERY_DELETE_DELIVERY_AREA": {
        "id": 138,
        "fields": [{
            "name": "areaName",
            "type": "string"
        }, {
            "name": "index",
            "type": "number"
        }, {
            "name": "source",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_CLICK_ON_SEARCH": {
        "id": 139,
        "fields": [{
            "name": "origin",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_MORE_CLICK": {
        "id": 140,
        "fields": [{
            "name": "clickType",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_SEARCH": {
        "id": 141,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_ORDERS_CENTER_CLICK_ON_ORDER": {
        "id": 142,
        "fields": [{
            "name": "order_id",
            "type": "string"
        }, {
            "name": "order_status",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_EXTERNAL_CLICKS": {
        "id": 143,
        "fields": [{
            "name": "clickType",
            "type": "string"
        }, {
            "name": "order_id",
            "type": "string"
        }, {
            "name": "order_status",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_ORDERS_CENTER_ACTION_IN_ORDER_MODAL": {
        "id": 144,
        "fields": [{
            "name": "isOnline",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "order_age",
            "type": "number"
        }, {
            "name": "order_id",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "rejectReason",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_PAYMENT_PAGE_SMS_VALIDATION_TOGGLE": {
        "id": 145,
        "fields": [{
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_PAYMENT_PAGE_ADVANCED_SETTINGS_SHOW": {
        "id": 146
    },
    "DASHBOARD_OLO_PAYMENT_PAGE_SPLIT_PAYMENTS": {
        "id": 147,
        "fields": [{
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_DELIVERY_EDIT_DELIVERY_AREA": {
        "id": 148,
        "fields": [{
            "name": "areaName",
            "type": "string"
        }, {
            "name": "index",
            "type": "number"
        }, {
            "name": "source",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_PAGE_LOAD": {
        "id": 149,
        "fields": [{
            "name": "delivery_status",
            "type": "string"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "rest_status",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "time_to_next_delivery_status",
            "type": "number"
        }, {
            "name": "time_to_next_rest_status",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_MENU_NAVIGATION": {
        "id": 150,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_ITEM_CLICK": {
        "id": 151,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "item_id",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "section_id",
            "type": "string"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_ADD_TO_CART": {
        "id": 152,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "item_id",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "section_id",
            "type": "string"
        }, {
            "name": "special_requests",
            "type": "string"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_CANCEL_ADD_TO_CART": {
        "id": 153,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "item_id",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "section_id",
            "type": "string"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_DELETE_ITEM_FROM_CART": {
        "id": 154,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "item_id",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "section_id",
            "type": "string"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_DUPLICATE_ITEM_IN_CART": {
        "id": 155,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "item_id",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "section_id",
            "type": "string"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_ORDER_NOW": {
        "id": 156,
        "fields": [{
            "name": "currency",
            "type": "string"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "kitchen_requests",
            "type": "string"
        }, {
            "name": "minimum_order",
            "type": "number"
        }, {
            "name": "num_items",
            "type": "number"
        }, {
            "name": "order_method",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "subtotal",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_DELIVERY_PAGE_PAGE_LOAD": {
        "id": 157,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "order_method",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_DELIVERY_PAGE_SWITCH_METHOD": {
        "id": 158,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "order_method",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_DELIVERY_PAGE_SET_ADDRESS": {
        "id": 159,
        "fields": [{
            "name": "address",
            "type": "string"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "results",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "isSuccess",
            "type": "boolean"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_DELIVERY_PAGE_PROCEED": {
        "id": 160,
        "fields": [{
            "name": "address",
            "type": "string"
        }, {
            "name": "apartment",
            "type": "string"
        }, {
            "name": "currency",
            "type": "string"
        }, {
            "name": "delivery_charges",
            "type": "number"
        }, {
            "name": "entrance",
            "type": "string"
        }, {
            "name": "floor",
            "type": "string"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "on_arrival",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "special_requests",
            "type": "string"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_DELIVERY_PAGE_BACK": {
        "id": 161,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_CONTACTS_PAGE_SET_CONTACT": {
        "id": 162,
        "fields": [{
            "name": "email_address",
            "type": "string"
        }, {
            "name": "first_name",
            "type": "string"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "last_name",
            "type": "string"
        }, {
            "name": "phone_number",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "valid_email_address",
            "type": "boolean"
        }, {
            "name": "valid_first_name",
            "type": "boolean"
        }, {
            "name": "valid_last_name",
            "type": "boolean"
        }, {
            "name": "valid_phone_number",
            "type": "boolean"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_CONTACTS_PAGE_BACK": {
        "id": 163,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_PAYMENT_PAGE_PAGE_LOAD": {
        "id": 164,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_PAYMENT_PAGE_METHOD_SELECTED": {
        "id": 165,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "isPopup",
            "type": "boolean"
        }, {
            "name": "payment_index",
            "type": "string"
        }, {
            "name": "pmnt_method",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_PAYMENT_PAGE_DELETE_METHOD": {
        "id": 166,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "payment_index",
            "type": "string"
        }, {
            "name": "pmnt_method",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_PAYMENT_PAGE_SPLIT_PAYMENT_CLICK": {
        "id": 167,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "payment_index",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_PAYMENT_PAGE_CREDIT_CARD_ADDED": {
        "id": 168,
        "fields": [{
            "name": "isCashier",
            "type": "boolean"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "isPopup",
            "type": "boolean"
        }, {
            "name": "payment_index",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_PAYMENT_PAGE_PROCEED": {
        "id": 169,
        "fields": [{
            "name": "currency",
            "type": "string"
        }, {
            "name": "grand_total",
            "type": "number"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "isSuccess",
            "type": "boolean"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "total_index_count",
            "type": "number"
        }, {
            "name": "total_paid",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_PAYMENT_PAGE_BACK": {
        "id": 170,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_CONFIRMATION_PAGE_PAGE_LOAD": {
        "id": 171,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_CONFIRMATION_PAGE_CONFIRM_ORDER_CLICK": {
        "id": 172,
        "fields": [{
            "name": "couponCode",
            "type": "string"
        }, {
            "name": "couponSubtotal",
            "type": "string"
        }, {
            "name": "currency",
            "type": "string"
        }, {
            "name": "delivery_charges",
            "type": "number"
        }, {
            "name": "discount_subtotal",
            "type": "number"
        }, {
            "name": "fixedItemDiscountSubtotal",
            "type": "number"
        }, {
            "name": "fixedItemNumDiscounts",
            "type": "number"
        }, {
            "name": "fixedOrderDiscountSubtotal",
            "type": "number"
        }, {
            "name": "fixedOrderNumDiscounts",
            "type": "number"
        }, {
            "name": "grand_total",
            "type": "number"
        }, {
            "name": "isCashier",
            "type": "boolean"
        }, {
            "name": "isCheckBox",
            "type": "boolean"
        }, {
            "name": "isConsent",
            "type": "boolean"
        }, {
            "name": "isExpressCheckout",
            "type": "boolean"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "nonContactDelivery",
            "type": "boolean"
        }, {
            "name": "num_discount",
            "type": "number"
        }, {
            "name": "num_items",
            "type": "number"
        }, {
            "name": "order_method",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "percentDiscountSubtotal",
            "type": "number"
        }, {
            "name": "percentNumDiscounts",
            "type": "number"
        }, {
            "name": "requestId",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "subtotal",
            "type": "number"
        }, {
            "name": "tax",
            "type": "number"
        }, {
            "name": "totalTip",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_ORDER_SMS_PAGE_LOAD": {
        "id": 173,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_ORDER_SENT_PAGE_LOAD": {
        "id": 174,
        "fields": [{
            "name": "couponCode",
            "type": "string"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "orderId",
            "type": "string"
        }, {
            "name": "requestId",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_ANTI_FRAUD_PAGE_LOAD": {
        "id": 175,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_ANTI_FRAUD_CONFIRM": {
        "id": 176,
        "fields": [{
            "name": "code_entered",
            "type": "string"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_ANTI_FRAUD_BACK": {
        "id": 177,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_ORDER_ERROR_PAGE_LOAD": {
        "id": 178,
        "fields": [{
            "name": "error_desc",
            "type": "string"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "requestId",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_CONTACTS_PAGE_PAGE_LOAD": {
        "id": 179,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "MENU_LOADED_ON_CLIENT": {
        "id": 180,
        "fields": [{
            "name": "view_mode",
            "type": "string"
        }]
    },
    "LIVE_SITE_MENU_PAGE_LOAD": {
        "id": 181,
        "fields": [{
            "name": "initialDispatchType",
            "type": "string"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "loadTime",
            "type": "number"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }, {
            "name": "zoomType",
            "type": "number"
        }]
    },
    "DASHBOARD_MENU_ADDED_DISHES": {
        "id": 182,
        "fields": [{
            "name": "menu",
            "type": "string"
        }]
    },
    "DASHBOARD_MENU_FB_CONNECT_ON_SET": {
        "id": 183,
        "fields": [{
            "name": "category",
            "type": "string"
        }, {
            "name": "is_auto_connect",
            "type": "boolean"
        }, {
            "name": "page_id",
            "type": "string"
        }, {
            "name": "page_name",
            "type": "string"
        }, {
            "name": "platform",
            "type": "string"
        }]
    },
    "DASHBOARD_MENU_FB_CONNECT_USE_PREVIOUS_PAGE": {
        "id": 184,
        "fields": [{
            "name": "page_id",
            "type": "string"
        }, {
            "name": "page_name",
            "type": "string"
        }]
    },
    "DASHBOARD_MENU_FB_CONNECT_PAGE_NOT_FOUND": {
        "id": 185,
        "fields": [{
            "name": "is_auto_connect",
            "type": "boolean"
        }, {
            "name": "platform",
            "type": "string"
        }]
    },
    "DASHBOARD_MENU_FB_CONNECT_NOT_YOUR_PAGE": {
        "id": 186,
        "fields": [{
            "name": "is_auto_connect",
            "type": "boolean"
        }, {
            "name": "page_id",
            "type": "string"
        }, {
            "name": "page_name",
            "type": "string"
        }, {
            "name": "platform",
            "type": "string"
        }]
    },
    "DASHBOARD_MENU_FB_CONNECT_ADD_TO_FB": {
        "id": 187,
        "fields": [{
            "name": "facebook_user_id",
            "type": "string"
        }, {
            "name": "is_auto_connect",
            "type": "boolean"
        }, {
            "name": "page_id",
            "type": "string"
        }, {
            "name": "page_name",
            "type": "string"
        }, {
            "name": "platform",
            "type": "string"
        }]
    },
    "DASHBOARD_MENU_FB_CONNECT_LINK_FB_RESULT": {
        "id": 188,
        "fields": [{
            "name": "facebook_user_id",
            "type": "string"
        }, {
            "name": "is_auto_connect",
            "type": "boolean"
        }, {
            "name": "page_id",
            "type": "string"
        }, {
            "name": "page_name",
            "type": "string"
        }, {
            "name": "platform",
            "type": "string"
        }, {
            "name": "reason",
            "type": "string"
        }, {
            "name": "result",
            "type": "string"
        }]
    },
    "DASHBOARD_MENU_FB_CONNECT_VIEW_ON_FB": {
        "id": 189,
        "fields": [{
            "name": "facebook_user_id",
            "type": "string"
        }, {
            "name": "is_auto_connect",
            "type": "boolean"
        }, {
            "name": "page_id",
            "type": "string"
        }, {
            "name": "page_name",
            "type": "string"
        }, {
            "name": "platform",
            "type": "string"
        }]
    },
    "DASHBOARD_MENU_FB_CONNECT_REMOVE_FROM_FB_RESULT": {
        "id": 190,
        "fields": [{
            "name": "facebook_user_id",
            "type": "string"
        }, {
            "name": "is_auto_connect",
            "type": "boolean"
        }, {
            "name": "page_id",
            "type": "string"
        }, {
            "name": "page_name",
            "type": "string"
        }, {
            "name": "platform",
            "type": "string"
        }, {
            "name": "reason",
            "type": "string"
        }, {
            "name": "result",
            "type": "string"
        }]
    },
    "DASHBOARD_UPGRADE_BUTTON_CLICKED": {
        "id": 191,
        "fields": [{
            "name": "is_auto_connect",
            "type": "boolean"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "platform",
            "type": "string"
        }]
    },
    "DASHBOARD_MENU_FB_CONNECT_REMOVE_FROM_FB": {
        "id": 192,
        "fields": [{
            "name": "facebook_user_id",
            "type": "string"
        }, {
            "name": "is_auto_connect",
            "type": "boolean"
        }, {
            "name": "page_id",
            "type": "string"
        }, {
            "name": "page_name",
            "type": "string"
        }, {
            "name": "platform",
            "type": "string"
        }]
    },
    "DASHBOARD_LEFT_NAV_CATEGORY_CLICK": {
        "id": 193,
        "fields": [{
            "name": "value",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_FREEMIUM_PAGE_OPEN": {
        "id": 194,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_TRY_CHECKOUT": {
        "id": 195,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_UPGRADE_BUTTON_CLICKED": {
        "id": 196,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "view_mode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "SETTINGS_RESET_DESIGN": {
        "id": 197,
        "fields": [{
            "name": "origin",
            "type": "string"
        }]
    },
    "SETTINGS_CHANGE_DESIGN": {
        "id": 198,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "SETTINGS_OPEN_BO_CLICK": {
        "id": 199,
        "fields": [{
            "name": "origin",
            "type": "string"
        }]
    },
    "SETTINGS_UPGRADE_BUTTON_CLICKED": {
        "id": 200,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "platform",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }]
    },
    "SETTINGS_TAB_CLICK": {
        "id": 201,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "FUTURE_ORDERS_TOGGLE": {
        "id": 202,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "FUTURE_ORDERS_APPLY": {
        "id": 203,
        "fields": [{
            "name": "my_orders_ind",
            "type": "string"
        }, {
            "name": "orders_time_frame",
            "type": "number"
        }, {
            "name": "origin",
            "type": "string"
        }]
    },
    "DASHBOARD_SETTINGS_NAVIGATION": {
        "id": 204,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "page_name",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }]
    },
    "EXPRESS_CHECKOUT_TOGGLE": {
        "id": 205,
        "fields": [{
            "name": "value",
            "type": "string"
        }]
    },
    "DISCOUNT_CREATE": {
        "id": 206,
        "fields": [{
            "name": "discount_id",
            "type": "string"
        }, {
            "name": "discountQuantity",
            "type": "number"
        }, {
            "name": "type",
            "type": "string"
        }]
    },
    "DISCOUNT_DUPLICATE": {
        "id": 207,
        "fields": [{
            "name": "src_discount_id",
            "type": "string"
        }, {
            "name": "trgt_discount_id",
            "type": "string"
        }]
    },
    "DISCOUNT_CHANGE_STATUS": {
        "id": 208,
        "fields": [{
            "name": "discount_id",
            "type": "string"
        }, {
            "name": "name",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DISCOUNT_ACTION": {
        "id": 209,
        "fields": [{
            "name": "discount_id",
            "type": "string"
        }, {
            "name": "field",
            "type": "string"
        }, {
            "name": "name",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "SOCIAL_BAR_SETTINGS_LOAD": {
        "id": 210
    },
    "SOCIAL_BAR_HIDE_PLATFORN": {
        "id": 211,
        "fields": [{
            "name": "platform",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "SOCIAL_BAR_LAYOUT": {
        "id": 212,
        "fields": [{
            "name": "category",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "SOCIAL_BAR_SET_LINKS_CLICK": {
        "id": 213
    },
    "LIVE_SITE_OLO_SOCIAL_CLICK": {
        "id": 214,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "platform",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_PAYMENT_PAGE_TRY_TO_CONNECT": {
        "id": 215,
        "fields": [{
            "name": "country",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_PAYMENT_PAGE_OUTCOME": {
        "id": 216,
        "fields": [{
            "name": "country",
            "type": "string"
        }, {
            "name": "outcome",
            "type": "string"
        }, {
            "name": "reason",
            "type": "string"
        }]
    },
    "DASHBOARD_AVAILABILITY_OPEN": {
        "id": 217,
        "fields": [{
            "name": "source",
            "type": "string"
        }]
    },
    "DASHBOARD_PAGE_LOAD": {
        "id": 220,
        "fields": [{
            "name": "category",
            "type": "string"
        }, {
            "name": "httpOrigin",
            "type": "string"
        }, {
            "name": "isOnline",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "page_name",
            "type": "string"
        }]
    },
    "DASHBOARD_BANNER_CLICK": {
        "id": 221,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }]
    },
    "MENU_PERFORMANCE": {
        "id": 222,
        "fields": [{
            "name": "body_render",
            "type": "number"
        }, {
            "name": "end_generate_locales",
            "type": "number"
        }, {
            "name": "end_initial_promise",
            "type": "number"
        }, {
            "name": "end_products",
            "type": "number"
        }, {
            "name": "file_locations_time",
            "type": "number"
        }, {
            "name": "group",
            "type": "string"
        }, {
            "name": "has_instance",
            "type": "number"
        }, {
            "name": "initial_promises_mode",
            "type": "string"
        }, {
            "name": "js_render",
            "type": "number"
        }, {
            "name": "organization_found_instances",
            "type": "number"
        }, {
            "name": "organization_found_org_time",
            "type": "number"
        }, {
            "name": "organization_success",
            "type": "number"
        }, {
            "name": "organization_time",
            "type": "number"
        }, {
            "name": "pageSize",
            "type": "number"
        }, {
            "name": "products_are_enabled",
            "type": "boolean"
        }, {
            "name": "serving_time",
            "type": "number"
        }, {
            "name": "ssr",
            "type": "number"
        }, {
            "name": "ssr_create_static_store",
            "type": "number"
        }, {
            "name": "ssr_instantiate_wss",
            "type": "number"
        }, {
            "name": "ssr_render_to_string",
            "type": "number"
        }, {
            "name": "ssr_total",
            "type": "number"
        }, {
            "name": "ssr_wix_style_parser",
            "type": "number"
        }, {
            "name": "ssr_wss_get",
            "type": "number"
        }, {
            "name": "start",
            "type": "number"
        }, {
            "name": "start_service",
            "type": "number"
        }, {
            "name": "styles_time",
            "type": "number"
        }, {
            "name": "total_server_time",
            "type": "number"
        }, {
            "name": "type",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "RESERAVTIONS_MANAGE_CLICK": {
        "id": 223
    },
    "RESERAVTIONS_SETTINGS": {
        "id": 224,
        "fields": [{
            "name": "category",
            "type": "string"
        }, {
            "name": "controller_name",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "RESERVATIONS_RESERVE_CLICK": {
        "id": 225,
        "fields": [{
            "name": "date",
            "type": "string"
        }, {
            "name": "hour",
            "type": "string"
        }, {
            "name": "isMerchant",
            "type": "boolean"
        }, {
            "name": "party",
            "type": "number"
        }, {
            "name": "time",
            "type": "number"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "RESERVATIONS_BOOK_A_TABLE_CLICK": {
        "id": 226,
        "fields": [{
            "name": "date",
            "type": "string"
        }, {
            "name": "hour",
            "type": "string"
        }, {
            "name": "isMerchant",
            "type": "boolean"
        }, {
            "name": "party",
            "type": "number"
        }, {
            "name": "time",
            "type": "number"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "RESERVATIONS_OUTCOME": {
        "id": 227,
        "fields": [{
            "name": "customFields",
            "type": "string"
        }, {
            "name": "isCheckBox",
            "type": "boolean"
        }, {
            "name": "isMerchant",
            "type": "boolean"
        }, {
            "name": "isConsent",
            "type": "string"
        }, {
            "name": "outcome",
            "type": "string"
        }, {
            "name": "partySize",
            "type": "number"
        }, {
            "name": "specialRequests",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "LIVE_SITE_MENU_LOAD": {
        "id": 228,
        "fields": [{
            "name": "is_server_side_rendering",
            "type": "boolean"
        }, {
            "name": "loading_time",
            "type": "number"
        }, {
            "name": "product",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "RESERVATIONS_FORM_VALIDATION": {
        "id": 229,
        "fields": [{
            "name": "consentError",
            "type": "string"
        }, {
            "name": "date_error",
            "type": "string"
        }, {
            "name": "email_error",
            "type": "string"
        }, {
            "name": "first_name_error",
            "type": "string"
        }, {
            "name": "last_name_error",
            "type": "string"
        }, {
            "name": "phone_number_error",
            "type": "string"
        }, {
            "name": "time_error",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "USABILITY_MODAL": {
        "id": 230,
        "fields": [{
            "name": "action",
            "type": "string"
        }]
    },
    "DASHBOARD_ADD_PRODUCT_TO_SITE": {
        "id": 231,
        "fields": [{
            "name": "product",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }, {
            "name": "target",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_PAYMENT_PAGE_TIP_ENABLE": {
        "id": 232,
        "fields": [{
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_PAYMENT_PAGE_SAVE": {
        "id": 233
    },
    "DASHBOARD_OLO_MY_ORDERS_TAB": {
        "id": 234,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "tab_name",
            "type": "string"
        }]
    },
    "TYPE_SELECTION_LOAD": {
        "id": 235
    },
    "TYPE_SELECTION": {
        "id": 236,
        "fields": [{
            "name": "restaurant_type",
            "type": "string"
        }]
    },
    "ONBOARDING_REST_TYPE_SKIP": {
        "id": 237
    },
    "MOBILE_ONLINE_ORDERING_FLOW": {
        "id": 238,
        "fields": [{
            "name": "group",
            "type": "string"
        }, {
            "name": "loadingTime",
            "type": "number"
        }, {
            "name": "stage",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "SET_NOTIFICATION": {
        "id": 239,
        "fields": [{
            "name": "channel",
            "type": "string"
        }, {
            "name": "delay_mins",
            "type": "number"
        }, {
            "name": "active",
            "type": "boolean"
        }, {
            "name": "notification_type",
            "type": "string"
        }, {
            "name": "time_modified",
            "type": "number"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "SET_NOTIFICATION_ERROR": {
        "id": 240,
        "fields": [{
            "name": "channel",
            "type": "string"
        }, {
            "name": "errorType",
            "type": "string"
        }, {
            "name": "notification_type",
            "type": "string"
        }, {
            "name": "time_modified",
            "type": "number"
        }]
    },
    "NOTIFICATIONS_ONLINE_CLICK": {
        "id": 241,
        "fields": [{
            "name": "screenName",
            "type": "string"
        }]
    },
    "MENUS_DUPLICATE_CLICK": {
        "id": 242,
        "fields": [{
            "name": "item_type",
            "type": "string"
        }]
    },
    "MENUS_DUPLICATE": {
        "id": 243,
        "fields": [{
            "name": "item_type",
            "type": "string"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "locationIdDestination",
            "type": "string"
        }, {
            "name": "locationIncluded",
            "type": "boolean"
        }, {
            "name": "locationsCount",
            "type": "number"
        }, {
            "name": "menuId",
            "type": "string"
        }, {
            "name": "menuIdDestination",
            "type": "string"
        }, {
            "name": "menusCount",
            "type": "number"
        }, {
            "name": "sectionId",
            "type": "string"
        }, {
            "name": "sectionIdDestination",
            "type": "string"
        }, {
            "name": "sectionsCount",
            "type": "number"
        }]
    },
    "MENUS_RESTORE_CLICK": {
        "id": 244,
        "fields": [{
            "name": "item_type",
            "type": "string"
        }]
    },
    "MENUS_RESTORE_FROM_ARCHIVE": {
        "id": 245,
        "fields": [{
            "name": "item_type",
            "type": "string"
        }]
    },
    "MENUS_NOTIFICATION_BAR_CLICK_ON_VIEW": {
        "id": 246
    },
    "MENUS_CLICK_ON_ADD_EXISTING": {
        "id": 247,
        "fields": [{
            "name": "item_type",
            "type": "string"
        }]
    },
    "MENUS_ADD_EXISTING": {
        "id": 248,
        "fields": [{
            "name": "item_type",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_PAYMENT_PAGE_CREDIT_CARD_ADD": {
        "id": 249,
        "fields": [{
            "name": "isMerchant",
            "type": "boolean"
        }, {
            "name": "organizationId",
            "type": "string"
        }, {
            "name": "paymentIndex",
            "type": "string"
        }, {
            "name": "pmntMethod",
            "type": "string"
        }, {
            "name": "screenWidth",
            "type": "number"
        }, {
            "name": "siteId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "DISCOUNT_COUPON_TOGGLE": {
        "id": 250,
        "fields": [{
            "name": "couponCode",
            "type": "string"
        }, {
            "name": "discountType",
            "type": "string"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "valueEnd",
            "type": "string"
        }, {
            "name": "valueOrigin",
            "type": "string"
        }]
    },
    "DISCOUNT_SAVE": {
        "id": 251,
        "fields": [{
            "name": "couponAfter",
            "type": "boolean"
        }, {
            "name": "couponBefore",
            "type": "boolean"
        }, {
            "name": "discountId",
            "type": "string"
        }, {
            "name": "discountTypeAfter",
            "type": "string"
        }, {
            "name": "discountTypeBefore",
            "type": "string"
        }, {
            "name": "discountValueAfter",
            "type": "number"
        }, {
            "name": "discountValueBefore",
            "type": "number"
        }, {
            "name": "limitAfter",
            "type": "number"
        }, {
            "name": "limitOrigin",
            "type": "number"
        }, {
            "name": "limitUse",
            "type": "boolean"
        }, {
            "name": "name",
            "type": "string"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "sessionId",
            "type": "string"
        }]
    },
    "OLO_PAYMENT_PAGE_ADD_COUPON_CODE": {
        "id": 252,
        "fields": [{
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "OLO_PAYMENT_PAGE_COUPON_CODE_APPLY_STARTED": {
        "id": 253,
        "fields": [{
            "name": "context",
            "type": "string"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "OLO_PAYMENT_PAGE_COUPON_CODE_APPLY_FINISHED": {
        "id": 254,
        "fields": [{
            "name": "context",
            "type": "string"
        }, {
            "name": "currency",
            "type": "string"
        }, {
            "name": "discount_subtotal",
            "type": "number"
        }, {
            "name": "errorType",
            "type": "string"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "isSuccess",
            "type": "boolean"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "sessionId",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "OLO_PAYMENT_PAGE_COUPON_CODE_CANCEL": {
        "id": 255,
        "fields": [{
            "name": "couponCode",
            "type": "string"
        }, {
            "name": "errorType",
            "type": "string"
        }, {
            "name": "is_merchant",
            "type": "boolean"
        }, {
            "name": "isSuccess",
            "type": "boolean"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "DISCOUNT_ERROR": {
        "id": 256,
        "fields": [{
            "name": "discount_id",
            "type": "string"
        }, {
            "name": "errorType",
            "type": "string"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "sessionId",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DISCOUNT_CANCEL": {
        "id": 257,
        "fields": [{
            "name": "discount_id",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }]
    },
    "DASHBOARD_AVAILABILITY_LOAD": {
        "id": 258,
        "fields": [{
            "name": "source_page",
            "type": "string"
        }, {
            "name": "type_origin",
            "type": "string"
        }]
    },
    "DASHBOARD_AVAILABILITY_NEW_EVENT": {
        "id": 259,
        "fields": [{
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "source_page",
            "type": "string"
        }]
    },
    "DASHBOARD_AVAILABILITY_NEW_CUSTOM": {
        "id": 260,
        "fields": [{
            "name": "button_name",
            "type": "string"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "source_page",
            "type": "string"
        }]
    },
    "DASHBOARD_AVAILABILITY_APPLY": {
        "id": 261,
        "fields": [{
            "name": "button_name",
            "type": "string"
        }, {
            "name": "iserror",
            "type": "boolean"
        }, {
            "name": "numberChanged",
            "type": "boolean"
        }, {
            "name": "numberOfCustomHours",
            "type": "number"
        }, {
            "name": "source_page",
            "type": "string"
        }, {
            "name": "type_hours",
            "type": "string"
        }, {
            "name": "type_hours_changed",
            "type": "boolean"
        }]
    },
    "DASHBOARD_AVAILABILITY_CANCEL": {
        "id": 262,
        "fields": [{
            "name": "buttonType",
            "type": "string"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "source_page",
            "type": "string"
        }]
    },
    "DASHBOARD_EDIT_SCHEDULE_LOAD": {
        "id": 263,
        "fields": [{
            "name": "rest_id",
            "type": "string"
        }]
    },
    "DASHBOARD_EDIT_SCHEDULE_APPLY": {
        "id": 264,
        "fields": [{
            "name": "numberOfrows",
            "type": "number"
        }, {
            "name": "numberChanged",
            "type": "boolean"
        }, {
            "name": "rest_id",
            "type": "string"
        }]
    },
    "DASHBOARD_AVAILABILITY_CUSTOM_HOURS_CLICK": {
        "id": 265,
        "fields": [{
            "name": "iserror",
            "type": "boolean"
        }]
    },
    "AVAILABILITY_ERROR_DAY": {
        "id": 266,
        "fields": [{
            "name": "iserror",
            "type": "boolean"
        }, {
            "name": "originpage",
            "type": "string"
        }, {
            "name": "weekday",
            "type": "string"
        }]
    },
    "AVAILABILITY_ERROR_HOURS": {
        "id": 267,
        "fields": [{
            "name": "iserror",
            "type": "boolean"
        }, {
            "name": "originpage",
            "type": "string"
        }, {
            "name": "status",
            "type": "boolean"
        }]
    },
    "AVAILABILITY_ERROR_SET_HOURS": {
        "id": 268,
        "fields": [{
            "name": "iserror",
            "type": "boolean"
        }, {
            "name": "originpage",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }]
    },
    "EDITOR_APP_SETTINGS_OPEN": {
        "id": 270,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "productName",
            "type": "string"
        }]
    },
    "EDITOR_APP_SETTINGS_CHANGE_ELEMENT": {
        "id": 271,
        "fields": [{
            "name": "newValue",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "parameter",
            "type": "string"
        }, {
            "name": "productName",
            "type": "string"
        }]
    },
    "EDITOR_APP_SETTINGS_CLICK_SECTION": {
        "id": 272,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "parameter",
            "type": "string"
        }, {
            "name": "productName",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_ORDER_SENT_TDS_START": {
        "id": 273,
        "fields": [{
            "name": "gatewayId",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_ORDER_SENT_TDS_COMPLETE": {
        "id": 274,
        "fields": [{
            "name": "isSuccess",
            "type": "boolean"
        }]
    },
    "LIVE_SITE_OLO_LOADING_SCREEN_IOS_LOAD": {
        "id": 275,
        "fields": [{
            "name": "organizationId",
            "type": "string"
        }]
    },
    "RESTAURANT_MODULE_DUMMY_EVENT": {
        "id": 276,
        "fields": [{
            "name": "value",
            "type": "string"
        }]
    },
    "ONE_APP_INTERACTION": {
        "id": 277,
        "fields": [{
            "name": "appName",
            "type": "string"
        }, {
            "name": "isOnline",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "ONE_APP_MENUS_ACTION": {
        "id": 278,
        "fields": [{
            "name": "isOnline",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "ONE_APP_SEARCH": {
        "id": 279,
        "fields": [{
            "name": "amountSearch",
            "type": "number"
        }, {
            "name": "app",
            "type": "string"
        }, {
            "name": "isOnline",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "searchTerm",
            "type": "string"
        }]
    },
    "PREVIEW_OLO_CLICK_PREVIEW": {
        "id": 280,
        "fields": [{
            "name": "clickType",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_RES_ADVANCED_SETTINGS_POLICIES_TOGGLE": {
        "id": 281,
        "fields": [{
            "name": "appName",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_RES_ADVANCED_SETTINGS_POLICIES_CLICK": {
        "id": 282,
        "fields": [{
            "name": "appName",
            "type": "string"
        }, {
            "name": "clickName",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_NAVIGATION": {
        "id": 283,
        "fields": [{
            "name": "clickType",
            "type": "string"
        }, {
            "name": "level",
            "type": "string"
        }, {
            "name": "pageName",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }]
    },
    "DASHBOARD_ADVANCED_SETTINGS_SAVE": {
        "id": 284,
        "fields": [{
            "name": "appName",
            "type": "string"
        }, {
            "name": "consent",
            "type": "boolean"
        }, {
            "name": "consentDescription",
            "type": "string"
        }, {
            "name": "customFieldsCount",
            "type": "number"
        }, {
            "name": "customFieldsCountRequired",
            "type": "number"
        }, {
            "name": "customFieldsNames",
            "type": "string"
        }, {
            "name": "expressCheckout",
            "type": "boolean"
        }, {
            "name": "futureLongBeforeDueDate",
            "type": "number"
        }, {
            "name": "futureOrderFrom",
            "type": "number"
        }, {
            "name": "futureOrderFromTo",
            "type": "string"
        }, {
            "name": "futureOrderTo",
            "type": "number"
        }, {
            "name": "futureOrders",
            "type": "boolean"
        }, {
            "name": "futureWhenAppear",
            "type": "string"
        }, {
            "name": "isError",
            "type": "boolean"
        }, {
            "name": "isSmsEnabled",
            "type": "boolean"
        }, {
            "name": "isTipEnabled",
            "type": "boolean"
        }]
    },
    "LIVE_SITE_OLO_CONFIRMATION_PAGE_CONSENT": {
        "id": 285,
        "fields": [{
            "name": "appName",
            "type": "string"
        }, {
            "name": "clickType",
            "type": "string"
        }, {
            "name": "consentDescription",
            "type": "string"
        }]
    },
    "ONE_APP_SETTINGS": {
        "id": 286,
        "fields": [{
            "name": "appName",
            "type": "string"
        }, {
            "name": "isOnline",
            "type": "boolean"
        }, {
            "name": "lastState",
            "type": "string"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "ONE_APP_ERROR": {
        "id": 287,
        "fields": [{
            "name": "appName",
            "type": "string"
        }, {
            "name": "errorReason",
            "type": "string"
        }, {
            "name": "isOnline",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }]
    },
    "ONE_APP_SUCCESS": {
        "id": 288,
        "fields": [{
            "name": "appName",
            "type": "string"
        }, {
            "name": "isOnline",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "ONE_APP_PRINTER_CONNECT_SUCCESS": {
        "id": 289,
        "fields": [{
            "name": "isOnline",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "printerName",
            "type": "string"
        }]
    },
    "DASHBOARD_DRAG_AND_DROP_MENUS_SECTIONS": {
        "id": 290,
        "fields": [{
            "name": "level",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_ARCHIVE_NAVIGATION": {
        "id": 291,
        "fields": [{
            "name": "tab_name",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_OPEN_INFO": {
        "id": 292,
        "fields": [{
            "name": "level",
            "type": "string"
        }]
    },
    "DASHBOARD_MENUS_ARCHIVE": {
        "id": 293,
        "fields": [{
            "name": "tab_name",
            "type": "string"
        }]
    },
    "LIVE_SITE_OLO_DELIVERY_PAGE_UOU_STARTED_TYPING_ADDRESS": {
        "id": 294,
        "fields": [{
            "name": "organizationId",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_OPEN_SETTINGS_CLICK": {
        "id": 295
    },
    "DASHBOARD_MENU_OPEN_MENU_CONSTRAINS": {
        "id": 296,
        "fields": [{
            "name": "editLevel",
            "type": "string"
        }, {
            "name": "organizationId",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }]
    },
    "MENUS_CLICK_ON_NEW_OPTION": {
        "id": 297,
        "fields": [{
            "name": "origin",
            "type": "string"
        }]
    },
    "ONE_APP_DEBUG": {
        "id": 298,
        "fields": [{
            "name": "appName",
            "type": "string"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "MENUS_SAVE_MENU_CONSTRAINS": {
        "id": 299,
        "fields": [{
            "name": "isDelivery",
            "type": "boolean"
        }, {
            "name": "isInStock",
            "type": "boolean"
        }, {
            "name": "isMobileSite",
            "type": "boolean"
        }, {
            "name": "isPhoneOrder",
            "type": "boolean"
        }, {
            "name": "isPickup",
            "type": "boolean"
        }, {
            "name": "isSite",
            "type": "boolean"
        }, {
            "name": "isSpecialRequest",
            "type": "boolean"
        }, {
            "name": "level",
            "type": "string"
        }]
    },
    "DASHBOARD_OLO_DELIVERY_EDIT_FIELD_IN_DELIVERY_AREA": {
        "id": 300,
        "fields": [{
            "name": "areaName",
            "type": "string"
        }, {
            "name": "field",
            "type": "string"
        }, {
            "name": "index",
            "type": "number"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "LOGIN": {
        "id": 301,
        "fields": [{
            "name": "appVersion",
            "type": "string"
        }, {
            "name": "device",
            "type": "string"
        }, {
            "name": "install_id",
            "type": "string"
        }, {
            "name": "is_resume",
            "type": "boolean"
        }, {
            "name": "mobile_version",
            "type": "string"
        }, {
            "name": "platform",
            "type": "string"
        }, {
            "name": "screen_height",
            "type": "number"
        }, {
            "name": "screen_width",
            "type": "number"
        }, {
            "name": "type",
            "type": "string"
        }, {
            "name": "uuid",
            "type": "string"
        }]
    },
    "PUSH_NOTIFICATIONS": {
        "id": 302,
        "fields": [{
            "name": "install_id",
            "type": "string"
        }, {
            "name": "uuid",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "ORDER_ACTION": {
        "id": 303,
        "fields": [{
            "name": "action",
            "type": "string"
        }, {
            "name": "install_id",
            "type": "string"
        }, {
            "name": "orderId",
            "type": "string"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }, {
            "name": "uuid",
            "type": "string"
        }]
    },
    "UNDO_ORDER_ACTION": {
        "id": 304,
        "fields": [{
            "name": "action",
            "type": "string"
        }, {
            "name": "install_id",
            "type": "string"
        }, {
            "name": "orderId",
            "type": "string"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "uuid",
            "type": "string"
        }]
    },
    "ORDER_DOCUMENTATION": {
        "id": 305,
        "fields": [{
            "name": "action",
            "type": "string"
        }, {
            "name": "install_id",
            "type": "string"
        }, {
            "name": "orderId",
            "type": "string"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "uuid",
            "type": "string"
        }]
    },
    "ERROR_REPORT": {
        "id": 306,
        "fields": [{
            "name": "brand",
            "type": "string"
        }, {
            "name": "device_name",
            "type": "string"
        }, {
            "name": "device_id",
            "type": "string"
        }, {
            "name": "error_msg",
            "type": "string"
        }, {
            "name": "install_id",
            "type": "string"
        }, {
            "name": "is_emulator",
            "type": "string"
        }, {
            "name": "manufacturer",
            "type": "string"
        }, {
            "name": "model",
            "type": "string"
        }, {
            "name": "operating_system",
            "type": "string"
        }, {
            "name": "user_agent",
            "type": "string"
        }, {
            "name": "uuid",
            "type": "string"
        }, {
            "name": "version",
            "type": "string"
        }]
    },
    "APP_ACTIVITY_STATUS": {
        "id": 307,
        "fields": [{
            "name": "activity_status",
            "type": "string"
        }, {
            "name": "install_id",
            "type": "string"
        }, {
            "name": "uuid",
            "type": "string"
        }]
    },
    "SOUND_SETTINGS_CHANGE": {
        "id": 308,
        "fields": [{
            "name": "install_id",
            "type": "string"
        }, {
            "name": "isActive",
            "type": "boolean"
        }, {
            "name": "uuid",
            "type": "string"
        }]
    },
    "BACKGROUND_SOUND_SETTINGS_CHANGE": {
        "id": 309,
        "fields": [{
            "name": "install_id",
            "type": "string"
        }, {
            "name": "isActive",
            "type": "boolean"
        }, {
            "name": "uuid",
            "type": "string"
        }]
    },
    "LOCALE_FALLBACK": {
        "id": 310,
        "fields": [{
            "name": "appVersion",
            "type": "string"
        }, {
            "name": "device",
            "type": "string"
        }, {
            "name": "fallback_locale",
            "type": "string"
        }, {
            "name": "install_id",
            "type": "string"
        }, {
            "name": "requested_locale",
            "type": "string"
        }, {
            "name": "uuid",
            "type": "string"
        }, {
            "name": "visitor_id",
            "type": "string"
        }]
    },
    "INSTALLATION": {
        "id": 311,
        "fields": [{
            "name": "appVersion",
            "type": "string"
        }, {
            "name": "device",
            "type": "string"
        }, {
            "name": "install_id",
            "type": "string"
        }, {
            "name": "operating_system",
            "type": "string"
        }]
    },
    "APP_FEEDBACK": {
        "id": 312,
        "fields": [{
            "name": "install_id",
            "type": "string"
        }, {
            "name": "rate",
            "type": "number"
        }, {
            "name": "review",
            "type": "string"
        }, {
            "name": "uuid",
            "type": "string"
        }]
    },
    "APP_NAVIGATION": {
        "id": 313,
        "fields": [{
            "name": "install_id",
            "type": "string"
        }, {
            "name": "orderId",
            "type": "string"
        }, {
            "name": "page_name",
            "type": "string"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "tabName",
            "type": "string"
        }, {
            "name": "uuid",
            "type": "string"
        }]
    },
    "RESERVATION_ACTION": {
        "id": 314,
        "fields": [{
            "name": "action",
            "type": "string"
        }, {
            "name": "install_id",
            "type": "string"
        }, {
            "name": "orderId",
            "type": "string"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }, {
            "name": "uuid",
            "type": "string"
        }]
    },
    "UNDO_RESERVATION_ACTION": {
        "id": 315,
        "fields": [{
            "name": "action",
            "type": "string"
        }, {
            "name": "install_id",
            "type": "string"
        }, {
            "name": "orderId",
            "type": "string"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "uuid",
            "type": "string"
        }]
    },
    "RESERVATION_DOCUMENTATION": {
        "id": 316,
        "fields": [{
            "name": "action",
            "type": "string"
        }, {
            "name": "install_id",
            "type": "string"
        }, {
            "name": "orderId",
            "type": "string"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "uuid",
            "type": "string"
        }]
    },
    "MENU_ACTION": {
        "id": 317,
        "fields": [{
            "name": "action",
            "type": "string"
        }, {
            "name": "install_id",
            "type": "string"
        }, {
            "name": "orderId",
            "type": "string"
        }, {
            "name": "rest_id",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }, {
            "name": "uuid",
            "type": "string"
        }]
    },
    "DASHBOARD_NOTIFICATIONS_ADD_EXTRA_NOTIFICATION": {
        "id": 318,
        "fields": [{
            "name": "appName",
            "type": "string"
        }, {
            "name": "orderType",
            "type": "string"
        }, {
            "name": "organizationId",
            "type": "string"
        }]
    },
    "DASHBOARD_NOTIFICATIONS_DELETE_NOTIFCATION": {
        "id": 319,
        "fields": [{
            "name": "appName",
            "type": "string"
        }, {
            "name": "orderType",
            "type": "string"
        }, {
            "name": "organizationId",
            "type": "string"
        }]
    },
    "DASHBOARD_NOTIFICATIONS_CANCEL": {
        "id": 320,
        "fields": [{
            "name": "appName",
            "type": "string"
        }]
    },
    "DASHBOARD_ADVANCED_SETTINGS_FUTURE_ORDERS_CLICKS": {
        "id": 321,
        "fields": [{
            "name": "appName",
            "type": "string"
        }, {
            "name": "clickName",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_RESERVATIONS_OPEN_SETTINGS_CLICK": {
        "id": 322
    },
    "DASHBOARD_POS_GETSTARTED": {
        "id": 323,
        "fields": [{
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "variant",
            "type": "string"
        }]
    },
    "DASHBOARD_POS_OPENSELECTPOS": {
        "id": 324,
        "fields": [{
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "variant",
            "type": "string"
        }]
    },
    "DASHBOARD_POS_USER_STARTED_TYPING": {
        "id": 325,
        "fields": [{
            "name": "field",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "variant",
            "type": "string"
        }]
    },
    "DASHBOARD_POS_CANCEL": {
        "id": 326,
        "fields": [{
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "variant",
            "type": "string"
        }]
    },
    "DASHBOARD_POS_SAVE": {
        "id": 327,
        "fields": [{
            "name": "domain",
            "type": "string"
        }, {
            "name": "pos",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "variant",
            "type": "string"
        }]
    },
    "DASHBOARD_POS_POS_SELECTED_IN_DROP_DOWN": {
        "id": 328,
        "fields": [{
            "name": "pos",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "variant",
            "type": "string"
        }]
    },
    "DASHBOARD_SOUND": {
        "id": 329,
        "fields": [{
            "name": "lastState",
            "type": "string"
        }]
    },
    "ONE_APP_LOCATIONPICKED": {
        "id": 330,
        "fields": [{
            "name": "appName",
            "type": "string"
        }, {
            "name": "isOnline",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "newLocation",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }]
    },
    "ONE_APP_LOCATIONTOGGLENOTIFICATION": {
        "id": 331,
        "fields": [{
            "name": "isOnline",
            "type": "boolean"
        }, {
            "name": "lastState",
            "type": "string"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "toggleLocationGuid",
            "type": "string"
        }]
    },
    "DASHBOARD_OPEN_VIDEO_TUTORIAL": {
        "id": 332,
        "fields": [{
            "name": "source_video",
            "type": "string"
        }]
    },
    "DASHBOARD_CLOSE_VIDEO_TUTORIAL": {
        "id": 333,
        "fields": [{
            "name": "source_video",
            "type": "string"
        }]
    },
    "DASHBOARD_LOAD_WITH_VIDEO": {
        "id": 334,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "source_video",
            "type": "string"
        }]
    },
    "DASHBOARD_RESERVATIONS_SETTINGS_CUSTOM_FIELDS": {
        "id": 335,
        "fields": [{
            "name": "type",
            "type": "string"
        }]
    },
    "PREVIEW_BANNER_CLICK": {
        "id": 336,
        "fields": [{
            "name": "product",
            "type": "string"
        }]
    },
    "PREVIEW_BANNER_LOAD": {
        "id": 337,
        "fields": [{
            "name": "product",
            "type": "string"
        }]
    },
    "APP_SETTINGS_UPGRADE_TO_PREMIUM_FOOTER_CLICK": {
        "id": 338
    },
    "DASHBOARD_OLO_PICKUP_PAGE_PICKUP_TOGGLE_CURBSIDE_PICKUP": {
        "id": 339,
        "fields": [{
            "name": "clickName",
            "type": "string"
        }, {
            "name": "organizationId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "RESERVATIONS_CHOOSE_RESERVATION_SETTINGS_CLICK_": {
        "id": 352,
        "fields": [{
            "name": "fieldName",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "DASHBOARD_MENU_OPEN_DO_IT_WITH_ME_VIDEO": {
        "id": 353,
        "fields": [{
            "name": "organizationId",
            "type": "string"
        }]
    },
    "DASHBOARD_BO_MORE_BUTTON": {
        "id": 354,
        "fields": [{
            "name": "appName",
            "type": "string"
        }]
    },
    "DASHBOARD_BANNER_VIEW": {
        "id": 355,
        "fields": [{
            "name": "origin",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }]
    },
    "DASHBOARD_RESERVATIONS_OVERVIEW_APPLY": {
        "id": 400,
        "fields": [{
            "name": "status",
            "type": "string"
        }, {
            "name": "off_time",
            "type": "string"
        }]
    },
    "DASHBOARD_RESERVATIONS_OVERVIEW_TOGGLE": {
        "id": 401,
        "fields": [{
            "name": "status",
            "type": "string"
        }, {
            "name": "locationGuid",
            "type": "string"
        }]
    },
    "DASHBOARD_RESERVATIONS_OVERVIEW_CANCEL": {
        "id": 402
    },
    "DASHBOARD_RESERVATIONS_OVERVIEW_EDIT": {
        "id": 403
    },
    "DASHBOARD_RESERVATIONS_PARTY_SIZE": {
        "id": 404,
        "fields": [{
            "name": "field",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_RESERVATIONS_HANDLING_EMAIL_EDIT": {
        "id": 405
    },
    "DASHBOARD_RESERVATIONS_HANDLING_EMAIL_APPLY": {
        "id": 406
    },
    "DASHBOARD_RESERVATIONS_HANDLING_EMAIL_TOGGLES": {
        "id": 407
    },
    "DASHBOARD_RESERVATIONS_HANDLING_EMAIL_CANCEL": {
        "id": 408
    },
    "DASHBOARD_RESERVATIONS_HANDLING_CONFIRMATION_TOGGLE": {
        "id": 409,
        "fields": [{
            "name": "active_status",
            "type": "boolean"
        }]
    },
    "DASHBOARD_RESERVATIONS_HANDLING_SMS_VALIDATION": {
        "id": 410,
        "fields": [{
            "name": "active_status",
            "type": "boolean"
        }]
    },
    "DASHBOARD_RESERVATIONS_MY_RESERVATIONS_TAB": {
        "id": 411,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "tab_name",
            "type": "string"
        }]
    },
    "DASHBOARD_RESERVATIONS_MY_RESERVATIONS_ACTION": {
        "id": 412,
        "fields": [{
            "name": "action",
            "type": "string"
        }, {
            "name": "isOnline",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "reservation__id",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_RESERVATIONS_MY_RESERVATIONS_BACK": {
        "id": 413
    },
    "DASHBOARD_RESERVATIONS_MY_RESERVATIONS_REJECT": {
        "id": 414,
        "fields": [{
            "name": "action",
            "type": "string"
        }, {
            "name": "is_value_null",
            "type": "boolean"
        }, {
            "name": "reservation__id",
            "type": "string"
        }]
    },
    "LIVE_SITE_SEATS_CANCEL_RESERVATION": {
        "id": 415,
        "fields": [{
            "name": "cancellation_reason",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "DASHBOARD_MENU_MODAL_ACTIONS": {
        "id": 500,
        "fields": [{
            "name": "action_name",
            "type": "string"
        }, {
            "name": "field",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "DASHBOARD_MENU_OPEN_MODAL": {
        "id": 501,
        "fields": [{
            "name": "name",
            "type": "string"
        }]
    },
    "DASHBOARD_MENU_BUTTON_CLICK": {
        "id": 502,
        "fields": [{
            "name": "name",
            "type": "string"
        }, {
            "name": "source",
            "type": "string"
        }]
    },
    "CALL_CENTER_DUMMY_NAME": {
        "id": 600
    },
    "CALL_CENTER_DUMMY_EVENT": {
        "id": 601,
        "fields": [{
            "name": "jsonData",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "CALL_CENTER_CHECKOUT_CLICK_ON_PAYMENT_METHOD_SELECTION": {
        "id": 602,
        "fields": [{
            "name": "payment_index",
            "type": "string"
        }, {
            "name": "pmnt_method",
            "type": "string"
        }]
    },
    "CALL_CENTER_CHECKOUT_CLICK_ON_REMOVE_PAYMENT_METHOD": {
        "id": 603,
        "fields": [{
            "name": "amount",
            "type": "number"
        }, {
            "name": "pmnt_method",
            "type": "string"
        }]
    },
    "CALL_CENTER_CHECKOUT_CHOOSE_CHECKOUT_METHOD": {
        "id": 604,
        "fields": [{
            "name": "checkout_method",
            "type": "string"
        }]
    },
    "CLICK_ON_DISH": {
        "id": 605,
        "fields": [{
            "name": "item_id",
            "type": "string"
        }, {
            "name": "item_name",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "withFilter",
            "type": "boolean"
        }]
    },
    "CANNOT_LOAD_SYSTEM": {
        "id": 606,
        "fields": [{
            "name": "organizationId",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }]
    },
    "LOAD_CALL_CENTER": {
        "id": 607,
        "fields": [{
            "name": "organizationId",
            "type": "string"
        }]
    },
    "PHONE_NUMBER_CLICK_CONTINUE": {
        "id": 608,
        "fields": [{
            "name": "isError",
            "type": "boolean"
        }, {
            "name": "organizationId",
            "type": "string"
        }, {
            "name": "phoneError",
            "type": "string"
        }]
    },
    "CUSTOMER_INFORMATION_CLICK_CONTINUE": {
        "id": 609,
        "fields": [{
            "name": "errorField",
            "type": "string"
        }, {
            "name": "isError",
            "type": "boolean"
        }, {
            "name": "isNewCustomer",
            "type": "boolean"
        }, {
            "name": "organizationId",
            "type": "string"
        }]
    },
    "ADDRESS_INFORMATION_CHANGE_DELIVERY_TYPE": {
        "id": 610,
        "fields": [{
            "name": "curbsidePickupContent",
            "type": "string"
        }, {
            "name": "curbsidePickupToggle",
            "type": "boolean"
        }, {
            "name": "deliveryType",
            "type": "string"
        }, {
            "name": "organizationId",
            "type": "string"
        }]
    },
    "ADDRESS_INFORMATION_FILL_CHANGE_ADDRESS": {
        "id": 611,
        "fields": [{
            "name": "isInDeliveryArea",
            "type": "boolean"
        }, {
            "name": "isNewAddress",
            "type": "boolean"
        }, {
            "name": "organizationId",
            "type": "string"
        }]
    },
    "ADDRESS_INFORMATION_CLICK_CONTINUE": {
        "id": 612,
        "fields": [{
            "name": "deliveryType",
            "type": "string"
        }, {
            "name": "hasComment",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "organizationId",
            "type": "string"
        }]
    },
    "NAVIGATION_PAGE": {
        "id": 613,
        "fields": [{
            "name": "organizationId",
            "type": "string"
        }, {
            "name": "pageName",
            "type": "string"
        }]
    },
    "CHANGE_BRANCH": {
        "id": 614,
        "fields": [{
            "name": "oldOrganizationID",
            "type": "string"
        }, {
            "name": "organizationId",
            "type": "string"
        }]
    },
    "CANCEL_ORDER_CLICK": {
        "id": 615,
        "fields": [{
            "name": "organizationId",
            "type": "string"
        }]
    },
    "HAMBURGER_MENU_CLICK": {
        "id": 616,
        "fields": [{
            "name": "organizationId",
            "type": "string"
        }]
    },
    "SIDE_MENU_CLICK": {
        "id": 617,
        "fields": [{
            "name": "menuId",
            "type": "string"
        }, {
            "name": "menuName",
            "type": "string"
        }, {
            "name": "organizationId",
            "type": "string"
        }, {
            "name": "sectionId",
            "type": "string"
        }, {
            "name": "sectionName",
            "type": "string"
        }]
    },
    "SIDE_MENU_CLICK_ON_CUSTOMER_SIDEBAR": {
        "id": 618,
        "fields": [{
            "name": "organizationId",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "MENU_FILTER": {
        "id": 619,
        "fields": [{
            "name": "isOpen",
            "type": "boolean"
        }, {
            "name": "organizationId",
            "type": "string"
        }]
    },
    "MENU_FILTER_OPTIONS": {
        "id": 620,
        "fields": [{
            "name": "organizationId",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }]
    },
    "CHECKOUT_WARNING": {
        "id": 621,
        "fields": [{
            "name": "errorType",
            "type": "string"
        }, {
            "name": "organizationId",
            "type": "string"
        }, {
            "name": "priceDiff",
            "type": "number"
        }]
    },
    "CART_CHANGE_DISH_AMOUNT": {
        "id": 622,
        "fields": [{
            "name": "itemId",
            "type": "string"
        }, {
            "name": "itemName",
            "type": "string"
        }, {
            "name": "newAmount",
            "type": "number"
        }, {
            "name": "organizationId",
            "type": "string"
        }]
    },
    "CALL_CENTER_EMPTY_STATE": {
        "id": 623,
        "fields": [{
            "name": "errorType",
            "type": "string"
        }, {
            "name": "organizationId",
            "type": "string"
        }]
    },
    "SUBMIT_ORDER_REQUEST": {
        "id": 624,
        "fields": [{
            "name": "idRequest",
            "type": "string"
        }, {
            "name": "organizationId",
            "type": "string"
        }]
    },
    "SUBMIT_ORDER_RESPONSE": {
        "id": 625,
        "fields": [{
            "name": "currency",
            "type": "string"
        }, {
            "name": "deliveryCharges",
            "type": "number"
        }, {
            "name": "errorDescription",
            "type": "string"
        }, {
            "name": "grandTotal",
            "type": "number"
        }, {
            "name": "idRequest",
            "type": "string"
        }, {
            "name": "isSuccess",
            "type": "boolean"
        }, {
            "name": "numDiscounts",
            "type": "number"
        }, {
            "name": "numItems",
            "type": "number"
        }, {
            "name": "orderId",
            "type": "string"
        }, {
            "name": "orderMethod",
            "type": "string"
        }, {
            "name": "organizationId",
            "type": "string"
        }]
    },
    "VIEW_CART": {
        "id": 803,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "totalItemsCount",
            "type": "number"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "GO_TO_CHECKOUT": {
        "id": 804,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "totalItemsCount",
            "type": "number"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "NAVIGATE_TO_MENU": {
        "id": 808,
        "fields": [{
            "name": "menuId",
            "type": "string"
        }, {
            "name": "menuName",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "NAVIGATE_TO_SECTION": {
        "id": 809,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "sectionId",
            "type": "string"
        }, {
            "name": "sectionName",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "DISPATCH_SETTINGS_UPDATE": {
        "id": 811,
        "fields": [{
            "name": "curbsideAdditionalInformationContent",
            "type": "string"
        }, {
            "name": "curbsidePickupToggle",
            "type": "boolean"
        }, {
            "name": "dispatchTime",
            "type": "number"
        }, {
            "name": "dispatchTimeOption",
            "type": "string"
        }, {
            "name": "dispatchType",
            "type": "string"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "validationError",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CHECKOUT_ADDRESS_INFORMATION_CONTINUE": {
        "id": 812,
        "fields": [{
            "name": "comment",
            "type": "string"
        }, {
            "name": "curbsideAdditionalInformationContent",
            "type": "string"
        }, {
            "name": "curbsidePickupToggle",
            "type": "boolean"
        }, {
            "name": "dispatchTime",
            "type": "number"
        }, {
            "name": "dispatchTimeOption",
            "type": "string"
        }, {
            "name": "dispatchType",
            "type": "string"
        }, {
            "name": "futureOrderTime",
            "type": "number"
        }, {
            "name": "isSaved",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CHECKOUT_ADDRESS_INFORMATION_CONTINUE_VALIDATION_ERROR": {
        "id": 813,
        "fields": [{
            "name": "comment",
            "type": "string"
        }, {
            "name": "dispatchTime",
            "type": "number"
        }, {
            "name": "dispatchTimeOption",
            "type": "string"
        }, {
            "name": "dispatchType",
            "type": "string"
        }, {
            "name": "errorReason",
            "type": "string"
        }, {
            "name": "isContactless",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CHECKOUT_CONTACT_INFORMATION_CONTINUE": {
        "id": 814,
        "fields": [{
            "name": "emailDomain",
            "type": "string"
        }, {
            "name": "isOverridden",
            "type": "boolean"
        }, {
            "name": "isSaved",
            "type": "boolean"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CHECKOUT_CONTACT_INFORMATION_CONTINUE_VALIDATION_ERROR": {
        "id": 815,
        "fields": [{
            "name": "errorReason",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CHECKOUT_PAYMENTS_INFORMATION_CONTINUE": {
        "id": 816,
        "fields": [{
            "name": "currency",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "paymentType",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "totalOrderValue",
            "type": "number"
        }, {
            "name": "totalTip",
            "type": "number"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CHECKOUT_PAYMENTS_INFORMATION_CONTINUE_VALIDATION_ERROR": {
        "id": 817,
        "fields": [{
            "name": "errorReason",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "paymentType",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "DISH_MODAL_DISCARD": {
        "id": 818,
        "fields": [{
            "name": "dishId",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "ADD_TO_CART_VALIDATION_ERROR": {
        "id": 819,
        "fields": [{
            "name": "dishId",
            "type": "string"
        }, {
            "name": "errorReason",
            "type": "string"
        }, {
            "name": "errorsCount",
            "type": "number"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CHECKOUT_BACK_TO_MENU": {
        "id": 820,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CART_DISH_QUANTITIES_UPDATE": {
        "id": 821,
        "fields": [{
            "name": "action",
            "type": "string"
        }, {
            "name": "dishId",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "quantity",
            "type": "number"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CART_REMOVE_DISH": {
        "id": 822,
        "fields": [{
            "name": "dishId",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CART_DISCARD": {
        "id": 823,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CART_DISCOUNT_DETAILS": {
        "id": 824,
        "fields": [{
            "name": "action",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CART_ADD_PROMO_CODE": {
        "id": 825,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CART_PROMO_CODE_APPLY_SUCCESS": {
        "id": 826,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "promoCode",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CART_PROMO_CODE_APPLY_FAILURE": {
        "id": 827,
        "fields": [{
            "name": "errorReason",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "promoCode",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CART_PROMOCODE_REMOVE": {
        "id": 828,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "promoCode",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CART_ADD_ORDER_NOTES": {
        "id": 829,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CHECKOUT_DISPATCH_UPDATE": {
        "id": 830,
        "fields": [{
            "name": "lastState",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CART_ORDER_NOTES_ADDED": {
        "id": 831,
        "fields": [{
            "name": "comment",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CHECKOUT_REVIEW_POLICIES": {
        "id": 832,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CHECKOUT_REVIEW_CHECKBOX": {
        "id": 833,
        "fields": [{
            "name": "lastState",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CHECKOUT_EDIT": {
        "id": 834,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "SMS_VALIDATION_DISPLAY": {
        "id": 835,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "SMS_VALIDATION_SUCCESS": {
        "id": 836,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "SMS_VALIDATION_FAILURE": {
        "id": 837,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "FUTURE_ORDERS_ERROR": {
        "id": 838,
        "fields": [{
            "name": "details",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "SMS_VALIDATION_CANCEL": {
        "id": 839,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CHECKOUT_NO_PAYMENT_METHOD": {
        "id": 840,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "DISH_MODAL_DISH_QUANTITIES_UPDATE": {
        "id": 841,
        "fields": [{
            "name": "action",
            "type": "string"
        }, {
            "name": "dishId",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "quantity",
            "type": "number"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "EDITOR_UPGRADE_TO_PREMIUM": {
        "id": 842,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "EDITOR_CONNECT_PAYMENT_CTA": {
        "id": 843,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "EDITOR_TOGGLE_OLO_CTA": {
        "id": 844,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "PREVIEW_ONBOARDING_MODAL_LOAD": {
        "id": 845,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "LOG_IN_REQUEST": {
        "id": 847,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "requestid",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "LOG_IN_SUCCESS": {
        "id": 848,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "requestid",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "OPEN_LOGOUT_CONFIRMATION_MODAL": {
        "id": 849,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "LOG_OUT_CONFIRMATION_MODAL_CTA_CLICK": {
        "id": 850,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "LOG_OUT_CONFIRMATION_MODAL_CANCEL_CLICK": {
        "id": 851,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CHECKBOX_SAVE_ADDRESS_FOR_FUTURE_ORDERS": {
        "id": 852,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "CHECKBOX_SAVE_CONTACT_FOR_FUTURE_ORDERS": {
        "id": 853,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "value",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "OPEN_ADDRESS_SELECTION_MODAL": {
        "id": 854,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "SAVE_ADDRESS_SELECTION_MODAL": {
        "id": 855,
        "fields": [{
            "name": "isDefault",
            "type": "boolean"
        }, {
            "name": "isSuccess",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "pageName",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "EDIT_ADDRESS_SELECTION_MODAL": {
        "id": 856,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "ADD_NEW_ADDRESS_SELECTION_MODAL": {
        "id": 857,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "SITE_MIGRATED_TO_OOI": {
        "id": 858,
        "fields": [{
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "viewMode",
            "type": "string"
        }]
    },
    "OOI_BANNER_CLICK": {
        "id": 860,
        "fields": [{
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }]
    },
    "INIT_SESSION": {
        "id": 901,
        "fields": [{
            "name": "instanceId",
            "type": "string"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "OPEN_DISH_MODAL": {
        "id": 902,
        "fields": [{
            "name": "dishId",
            "type": "string"
        }, {
            "name": "instanceId",
            "type": "string"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "origin",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "OPEN_DISPATCH_SETTINGS": {
        "id": 903,
        "fields": [{
            "name": "instanceId",
            "type": "string"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "ADD_TO_CART": {
        "id": 904,
        "fields": [{
            "name": "dishId",
            "type": "string"
        }, {
            "name": "instanceId",
            "type": "string"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "quantity",
            "type": "number"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "type",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "SUBMIT_ORDER_FAILURE": {
        "id": 905,
        "fields": [{
            "name": "instanceId",
            "type": "string"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloRequestId",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "rejectReason",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "SUBMIT_ORDER_SUCCESS": {
        "id": 906,
        "fields": [{
            "name": "instanceId",
            "type": "string"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloRequestId",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "orderId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "SUBMIT_ORDER": {
        "id": 907,
        "fields": [{
            "name": "currency",
            "type": "string"
        }, {
            "name": "discount_subtotal",
            "type": "number"
        }, {
            "name": "futureOrderTime",
            "type": "number"
        }, {
            "name": "instanceId",
            "type": "string"
        }, {
            "name": "isContactless",
            "type": "boolean"
        }, {
            "name": "isCustomTip",
            "type": "boolean"
        }, {
            "name": "isDefaultTip",
            "type": "boolean"
        }, {
            "name": "isMember",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloRequestId",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "tipSubtotal",
            "type": "number"
        }, {
            "name": "tipType",
            "type": "string"
        }, {
            "name": "total",
            "type": "number"
        }, {
            "name": "totalItemsCount",
            "type": "number"
        }, {
            "name": "viewMode",
            "type": "string"
        }, {
            "name": "visitorId",
            "type": "string"
        }]
    },
    "DISPATCH_SETTINGS_OPEN_ADD_ADDRESS": {
        "id": 930,
        "fields": [{
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }]
    },
    "CHECKOUT_TIP": {
        "id": 935,
        "fields": [{
            "name": "currency",
            "type": "string"
        }, {
            "name": "isCustomTip",
            "type": "boolean"
        }, {
            "name": "isDefaultTip",
            "type": "boolean"
        }, {
            "name": "locationGuid",
            "type": "string"
        }, {
            "name": "oloSessionId",
            "type": "string"
        }, {
            "name": "restaurantId",
            "type": "string"
        }, {
            "name": "tipSubtotal",
            "type": "number"
        }, {
            "name": "tipValue",
            "type": "number"
        }]
    },
    "DUMMY_EVENT": {
        "id": 1000
    },
    "TEST": {
        "id": 123456
    }
};